import { Vue, Options } from 'vue-class-component';
import { Inject, Watch } from 'vue-property-decorator';
import { CoreModuleContext } from '@/store/core';
import { WriteupModuleContext } from '@/store/writeup';
import { Modal } from '@/components/modal';
import { TopBar } from '@/components/top-bar';
import { Scrollable } from '@/components/scrollable';
import { RouterView } from 'vue-router';
import { Routes } from '@/router/routes';
import styles from './styles.module.scss';

@Options({
	name: 'App',
})
export class App extends Vue {
	@Inject() readonly coreModule!: CoreModuleContext;

	@Inject() readonly writeupModule!: WriteupModuleContext;

	get isWriteupError() { return this.writeupModule.getters.isError; }

	get isCoreError() { return this.coreModule.getters.isError; }

	@Watch('isWriteupError')
	@Watch('isCoreError')
	handleError() {
		if (!this.isWriteupError && !this.isCoreError) { return; }
		this.coreModule.actions.showError();
	}

	handleSave() {
		this.coreModule.actions.navigateTo(Routes.SAVE_MY_DEAL_FORM.path);
	}

	handleClose() {
		this.coreModule.actions.toggleModal();
	}

	render() {
		interface RouterSlots {
			Component: object;
		}

		// Router view can not be placed inside transition, so we should do it over slots
		const routerSlots = {
			default: ({ Component }: RouterSlots) => (
				<Modal onBackdropClick={ this.coreModule.actions.toggleModal }
					isOpen={ this.coreModule.getters.isModalOpen }>
					<div class={ styles.precisePrice }>
						<TopBar
							onClose={ this.handleClose }
							onSave={ this.handleSave }></TopBar>
						<Scrollable>
							{ Component }
						</Scrollable>
					</div>
				</Modal>
			),
		};

		return (
			<RouterView v-slots={ routerSlots }></RouterView>
		);
	}
}
